import React from 'react';
interface CautionNoteProps {
  title?: string;
  children: React.ReactNode;
}
export function CautionNote({
  title = 'Before you cut',
  children
}: CautionNoteProps) {
  return <aside className="rp-measure border-l-2 border-copper bg-warm px-5 py-4" data-id="element-537" data-mp="1a2atakc1ajh3">
      <p className="font-mono text-[10px] tracking-label text-copper" data-id="element-538" data-mp="1a07t57h639yn">
        {title.toUpperCase()}
      </p>
      <div className="mt-2 space-y-2 text-[14px] leading-[1.7] text-graphite/90" data-id="element-539" data-mp="1euvgh30fpybn">
        {children}
      </div>
    </aside>;
}